import NDA from "assets/DownloadPDFfile/NDA.docx";
import NCA from "assets/DownloadPDFfile/NCA.docx";
import EmployeeAgreement from "assets/DownloadPDFfile/Employment Agreement.docx";
import I9 from "assets/DownloadPDFfile/i-9.pdf";
import W4 from "assets/DownloadPDFfile/fw4.pdf";
import HRPolicy from "assets/DownloadPDFfile/HR Policy.pdf";
import OfferLetter from "assets/DownloadPDFfile/Offer Letter.pdf";
import colors from "Common/colors";

const items = [
  { id: 1, title: "NDA", key: "ndafile", type: "upload", pdfUrl: NDA, color: colors.color1 },
  { id: 2, title: "NCA", key: "ncafile", type: "upload", pdfUrl: NCA, color: colors.color2 },
  {
    id: 3,
    title: "Employee Agreement",
    key: "employeeAgreement",
    type: "upload",
    pdfUrl: EmployeeAgreement,
    color: colors.color3,
  },
  { id: 4, title: "I-9", key: "i_nine", type: "upload", pdfUrl: I9, color: colors.color4 },
  { id: 5, title: "W-4", key: "w_four", type: "upload", pdfUrl: W4, color: colors.color5 },
  {
    id: 6,
    title: "Offer Letter",
    key: "offerLetter",
    type: "upload",
    pdfUrl: OfferLetter,
    color: colors.color6,
  },
  {
    id: 7,
    title: "HR Policy",
    key: "hrPolicy",
    type: "download",
    pdfUrl: HRPolicy,
    color: colors.color7,
  },
];

export default items;
